import type { ReactNode } from "react";
import { useOrg } from "../shell/OrgContext";
import { MembersTab } from "./MembersTab";

/**
 * Route adapter for `/orgs/:orgId/members`: reads the org id and name from
 * `OrgContext` and renders the `MembersTab`. `RequireOrgAdmin` guards the
 * route; this adapter only wires the props.
 */
export function MembersRoute(): ReactNode {
  const { orgId, res } = useOrg();
  return <MembersTab orgId={orgId} orgName={res.name} />;
}
